
























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import BehaviorConfig from '@/models/app-config/behavior/behavior'

@Component
export default class OrderCarat extends Vue {
  @Prop({ required: true })
  rewardCarat: number

  @Prop({ required: true })
  expectedCarat: number

  behaviorConfig = new BehaviorConfig()

  formatCarat(carat: number): string {
    return carat.toLocaleString('ja-JP')
  }
}
